import { useAxios } from "../../../../../../hooks/useAxios"
import { OfertaAdapters, OfertasAdapters } from "./ofertas.adapter"


const OfertasServices = {

    GET: function () {

        return useAxios({ method: 'get', url: `/bolsadetrabajo/ofertasempleo`, type: 'json', adapters: OfertasAdapters.GET })
    },
    
}

const OfertaServices = {

    GET: function (id: string) {

        return useAxios({ method: 'get', url: `/bolsadetrabajo/ofertasempleo/${id}`, type: 'json', adapters: OfertaAdapters.GET })
    },

    GET_FICHA: function () {

        return useAxios({ method: 'get', url: `/bolsadetrabajo/ofertasempleo`, type: 'json', adapters: OfertaAdapters.GET_FICHA })
    },

    GET_BUSCAR_PERSONAS: function (id: string) {

        return useAxios({ method: 'get', url: `/bolsadetrabajo/admin/ofertasempleo/${id}/buscar`, type: 'json', adapters: OfertaAdapters.GET_BUSCAR_PERSONAS })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/bolsadetrabajo/admin/ofertasempleo`, type: 'json', adapters: OfertaAdapters.POST })
    },

    PATCH: function (idevento: string) {

        return useAxios({ method: 'patch', url: `/bolsadetrabajo/admin/ofertasempleo/${idevento}`, type: 'json', adapters: OfertaAdapters.PATCH })
    },

    PATCH_CHANGE_ESTADO: function (idevento: string) {

        return useAxios({ method: 'patch', url: `/inscripciones-bolsa/eventos/${idevento}`, type: 'json', adapters: OfertaAdapters.PATCH_CHANGE_ESTADO })
    },

    DELETE: function (idvisado: any) {

        return useAxios({ method: 'delete', url: `/inscripciones-bolsa/eventos/${idvisado}`, type: 'json', adapters: OfertaAdapters.DELETE })
    },

    PATCH_IMAGEN: function (idevento: string) {

        return useAxios({ method: 'post', url: `/inscripciones-bolsa/eventos/${idevento}/imagenlistado/subir?_method=PATCH`, type: 'json', adapters: OfertaAdapters.PATCH_IMAGEN })
    },

    DELETE_IMAGEN: function (idvisado: any) {

        return useAxios({ method: 'delete', url: `/inscripciones-bolsa/eventos/${idvisado}/imagenlistado/eliminar`, type: 'json', adapters: OfertaAdapters.DELETE_IMAGEN })
    },

    PATCH_NIVEL_IDIOMA: function (id: string) {

        return useAxios({ method: 'patch', url: `/bolsadetrabajo/admin/ofertasempleo/${id}/idiomas`, type: 'json', adapters: OfertaAdapters.PATCH_NIVEL_IDIOMA })
    },

    PATCH_TIPO_ESTUDIO: function (id: string) {

        return useAxios({ method: 'patch', url: `/bolsadetrabajo/admin/ofertasempleo/${id}/tiposestudios`, type: 'json', adapters: OfertaAdapters.PATCH_TIPO_ESTUDIO })
    },

    PATCH_FUNCION: function (id: string) {

        return useAxios({ method: 'patch', url: `/bolsadetrabajo/admin/ofertasempleo/${id}/funciones`, type: 'json', adapters: OfertaAdapters.PATCH_FUNCION })
    },
}

export {
    OfertasServices,
    OfertaServices
}